import React from 'react'
import { SegmentedController } from '@paypalcorp/pp-react'
import { ITabPanelProps } from './TabPanel'

export interface ITabsContainerProps {
  name: string
}

export const TabsContainer: React.FC<ITabsContainerProps> = ({
  children,
  name = 'TabsGroup1',
}) => {
  const panels = React.useMemo(
    () =>
      (Array.isArray(children) ? children : [children]).filter(
        (child) => child.props.mdxType === 'TabPanel',
      ),
    [children],
  )

  const tabs = React.useMemo(
    () =>
      panels.map(({ props }: { props: ITabPanelProps }) => ({
        label: props.label,
        id: props.id,
        panelId: `tab-${props.id}`,
      })),
    [panels],
  )

  const [selectedTab, setSelectedTab] = React.useState<number>(0)

  const onTabChange = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    tabIdx?: number | undefined,
  ) => {
    if (typeof tabIdx === 'undefined') return
    setSelectedTab(tabIdx)
  }

  return (
    <>
      <SegmentedController
        name={name}
        selectedTabIdx={selectedTab}
        tabs={tabs}
        onClick={onTabChange}
      >
        {children}
      </SegmentedController>
    </>
  )
}

export default TabsContainer
